import { useCallback } from "react"

type OutboundClickMeta = {
  label: string
  placement: string
  channel: "whatsapp" | "email" | "phone" | "external"
}

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    dataLayer?: unknown[]
  }
}

export function useOutboundTracking() {
  return useCallback((url: string, meta: OutboundClickMeta) => {
    if (typeof window === "undefined") {
      return
    }

    window.gtag?.("event", "outbound_click", {
      event_category: "engagement",
      event_label: meta.label,
      link_url: url,
      placement: meta.placement,
      channel: meta.channel,
    })

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push({
        event: "outbound_click",
        link_url: url,
        ...meta,
      })
    }
  }, [])
}
